import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Login from "./components/views/Login";
import Dashboard from "./components/views/Dashboard";
import NotFound from "./components/views/404NotFound";
import AdminRoutes from "./routes/AdminRoutes";
import WebsiteRoutes from "./routes/WebsiteRoutes";

import "./App.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";
import "./components/views/Nav/ShowHideSideBar.jsx";
import "./assets/dist/css/adminlte.min.css";
import "./plugins/fontawesome-free/css/all.min.css";
import "./plugins/tempusdominus-bootstrap-4/css/tempusdominus-bootstrap-4.min.css";
import "./plugins/icheck-bootstrap/icheck-bootstrap.min.css";
import "./plugins/jqvmap/jqvmap.min.css";
import "react-bootstrap-typeahead/css/Typeahead.css";
import "./plugins/overlayScrollbars/css/OverlayScrollbars.min.css";
import "./plugins/daterangepicker/daterangepicker.css";
import "./plugins/summernote/summernote-bs4.css";
import "./plugins/select2/css/select2.min.css";
import "./file.css";
import "./plugins/select2-bootstrap4-theme/select2-bootstrap4.min.css";
import "./assets/plugins/multiselect/css/multi-select.css";
import "./plugins/datatables-bs4/css/dataTables.bootstrap4.css";
import "./assets/plugins/dropify/dist/css/dropify.min.css";
import "./assets/plugins/bootstrap-datepicker/bootstrap-datepicker.min.css";
import "./assets/plugins/bootstrap-material-datetimepicker/css/bootstrap-material-datetimepicker.css";

function App() {
  const { role: Role, login } = useSelector((state) => state.auth);

  return (
    <div>
      <Router>
        <Routes>
          <Route path="/dash" element={<Dashboard />} />
          {Role === "Website" && WebsiteRoutes}
          {Role === "Admin" && AdminRoutes}
          <Route
            path="/"
            element={
              !login
                ? <Navigate to="/login" />
                : Role === "Website"
                  ? <Navigate to="/treatment-dashboard" />
                  : Role === "Admin"
                    ? <Navigate to="/category" />
                    : <Navigate to="/login" />
            }
          />
          <Route
            path="/login"
            element={login ? <Navigate to="/" /> : <Login />}
          />
          {login && Role && (
            <Route path="*" element={<Navigate to="/404" />} />
          )}
          {!login && (
            <Route path="*" element={<Navigate to="/login" />} />
          )}
          <Route path="/404" element={<NotFound />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
